import { c as _c } from "react/compiler-runtime";
import { Separator } from '@/components';

// mileage
export const Mileage = t0 => {
  const $ = _c(8);
  const {
    d
  } = t0;
  if (!d) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Separator />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== d) {
    t2 = d.toLocaleString();
    $[1] = d;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="font-semibold">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="ml-1 font-light">miles</span>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <>{t1}<div className="text-sm">{t3}{t4}</div></>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};